import React, {useEffect, useRef, useState, useMemo} from "react";
import {inject, observer} from "mobx-react";
// local
import {OrganizationCard} from "./OrganizationCard";
import OrganizationCardHead from "./OrganizationCardHead";
import TableTitleResult from "components/Table/TableTitleResult";
import {SubscriptionUpgradeCustomLocalModal} from "components/modals/SubscriptionUpgradeCustomLocalModal";
import {hasPermission} from "helpers/helper";
import cn from "classnames";

const SubscriptionUpgrageLocalModalPermissions = [
  "READ_TABLE_CREDIT_RATING",
  "READ_TABLE_TURNOVER",
  "READ_TABLE_COLLECTIVE_UNION_AGREEMENTS",
  "READ_TABLE_INSURANCE",
  "READ_TABLE_TAX_VAT_EMPLOYERS",
];

const Organizations = inject("store")(
  observer(
    ({
      store: {buyer, organization, auth},
      filteredRecipients,
      addedRecipients,
      onActionClick,
      onChangeOrder,
      onSelectChange,
      loadMoreRecipients, // Новый пропс: функция для загрузки следующего чанка
    }) => {
      const {user} = auth;
      const {
        favoritesOrganization,
        blacklistOrganization,
        organizationMembers,
        markings,
      } = organization;
      const {newPublishedRFPRecipients} = buyer;

      const [recipients, setRecipients] = useState(filteredRecipients);
      const listRef = useRef(null);

      const isResults = useMemo(
        () => !!filteredRecipients?.totalItems,
        [filteredRecipients]
      );
      const modalAddedRecipientsCount =
        addedRecipients?.length - newPublishedRFPRecipients.notRemoveRegistered?.length;

      const loadNextPageData = async () => {
        if (!(recipients?.totalPages - 1 >= recipients?.currentPage)) return;
        const nextPage = ++recipients.currentPage;
        const nextData = await loadMoreRecipients(nextPage);
        setRecipients((prev) => ({
          ...nextData,
          organizations: [...prev.organizations, ...nextData.organizations],
        }));
        listRef.current.addEventListener("scroll", handleScroll);
      };

      // eslint-disable-next-line react-hooks/exhaustive-deps
      const handleScroll = () => {
        const scrollPosition = listRef.current.scrollTop + listRef.current.clientHeight;
        const maxScrollPosition = listRef.current.scrollHeight - 2000;
        if (listRef.current && scrollPosition >= maxScrollPosition) {
          listRef.current.removeEventListener("scroll", handleScroll);
          loadNextPageData();
        }
      };

      useEffect(() => {
        const container = listRef.current;
        if (container) {
          container.addEventListener("scroll", handleScroll);
          return () => container.removeEventListener("scroll", handleScroll);
        }
      }, [handleScroll]);

      // initialazing list on first render
      useEffect(() => {
        if (!!filteredRecipients) {
          setRecipients(filteredRecipients);
          listRef?.current.scrollTo({top: 0, behavior: "smooth"});
        }
      }, [filteredRecipients]);

      return (
        <div className={cn("organizations", {__results: isResults})}>
          {!hasPermission(SubscriptionUpgrageLocalModalPermissions) && (
            <SubscriptionUpgradeCustomLocalModal
              canPermissions={SubscriptionUpgrageLocalModalPermissions}
              needDirectPurchase
              addClass="filtered-recipients-modal-positioning"
            >
              <div>
                {/* No upsales here yet. this will be a place where we can add upsales graphics */}
              </div>
            </SubscriptionUpgradeCustomLocalModal>
          )}
          <TableTitleResult
            title={"RESULTS"}
            totalItems={filteredRecipients?.totalItems ?? 0}
          />
          <OrganizationCardHead
            onChangeOrder={onChangeOrder}
            total={filteredRecipients?.totalItems ?? 0}
            added={modalAddedRecipientsCount}
            onSelectChange={onSelectChange}
            historySorting
          />
          <div className="organizations__suppliers" ref={listRef}>
            {isResults &&
              recipients?.organizations.map((organization) => (
                <OrganizationCard
                  key={organization.id}
                  cantBeRemoved={newPublishedRFPRecipients.notRemoveRegistered
                    ?.map((item) => item.id)
                    .includes(organization.id)}
                  isAlreadyInRecipients={addedRecipients
                    ?.map((item) => item.id ?? item.SellerId)
                    .includes(organization.id)}
                  organization={organization}
                  markings={markings}
                  favorites={favoritesOrganization}
                  blacklisted={blacklistOrganization}
                  onActionClick={onActionClick}
                  showTitleIcon
                  hasSuppliersQualifications={
                    !!organization.SupplierQualifications?.length
                  }
                  isEnableSuppliersQualification={
                    user.ActiveOrganization?.enableSuppliersQualification
                  }
                  currentUser={user}
                  currentOrganizationMembers={organizationMembers}
                />
              ))}
          </div>
        </div>
      );
    }
  )
);

export default Organizations;
